import { z } from "zod"

const emailSchema = z.string().email({ message: "Email must be valid" })

const requiredSchema = z.object({
  model: z.string(),
  action_id: z.number(),
  send_email_notification: z.boolean(),
  assign_to_ids: z.array(z.number()),
  attachment_docs: z.array(z.number()),
  cc_emails: z.array(z.string()),
  additional_email_text: z.string().optional(),
  create_action_item: z.boolean(),
  inform_team: z.boolean(),
  inform_team_data: z
    .object({
      inform_team_ids: z.array(z.number()),
      inform_team_cc: z.array(z.string()),
    })
    .optional(),
  cancel_action_item_ids: z.array(z.number()), // no longer on UI
})

const commentSchema = z.object({
  comment_data: z
    .object({
      text: z.string(),
      tags: z.array(z.string()), // no longer on UI
    })
    .optional(),
})

const expressCompleteSchema = requiredSchema.merge(commentSchema).merge(
  z.object({
    review_approve_data: z.object({
      study_id: z.string().optional(), // optional on request workflows
      form_types: z.array(),
      form_version: z.string(),
      comment_types: z.array(),
      documents: z.array(),
    }),
  })
)

const PRIORITIES = {
  High: 2,
  Medium: 1,
  Low: 0,
}

const sendActionItemSchema = requiredSchema.merge(commentSchema).merge(
  z.object({
    actionitem_data: z.object({
      title: z.string(),
      due_date: z.string(),
      priority: z.nativeEnum(PRIORITIES),
    }),
  })
)

const reviewApprovalSchema = requiredSchema.merge(sendActionItemSchema).merge(
  z.object({
    review_approve_data: z.object({
      study_id: z.string().optional(), // not required for requests
      form_types: z.array(
        z.object({
          form_view: z.string(),
          form_section: z.string(),
        })
      ),
      form_version: z.number(),
      comment_types: z.array(z.string()),
      form_compare_version: z.number().optional(),
      documents: z.array(z.number()),
    }),
  })
)

export {
  // zod validation schemas
  emailSchema,
  expressCompleteSchema,
  requiredSchema,
  sendActionItemSchema,
  reviewApprovalSchema,
}
